<side-panel [stepData]="stepData">
    <ng-template let-rowDetail #contentSidePanel>
        <div class="configuration-fields" *ngIf="rowDetail.name=='Nome'">
            <div class="content">
                <form [formGroup]="form" nz-form nzLayout="vertical">
                    <div nz-row [nzGutter]="[8, 4]">
                        <div nz-col [nzSpan]="12">
                            <nz-form-item>
                                <nz-form-label>Título</nz-form-label>
                                <nz-form-control>
                                    <input nz-input type="text" formControlName="title">
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="12">
                            <nz-form-item>
                                <nz-form-label>Título da Duração</nz-form-label>
                                <nz-form-control>
                                    <input nz-input type="text" formControlName="duration">
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="12">
                            <nz-form-item>
                                <nz-form-label>Tipo de Ícone</nz-form-label>
                                <nz-form-control>
                                    <nz-select formControlName="type" (ngModelChange)="getIconsInfo($event)">
                                        <nz-option *ngFor="let data of typeIcon" [nzValue]="data.id"
                                            [nzLabel]="data.id + ' - ' + data.name"></nz-option>
                                    </nz-select>
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="12">
                            <nz-form-item>
                                <nz-form-label>Ícone</nz-form-label>
                                <nz-form-control>
                                    @if( type != null && type == 'svg'){
                                        <nz-select formControlName="icon" nzShowSearch>
                                            <nz-option *ngFor="let data of icons | async" [nzValue]="data.id"
                                                [nzLabel]="data.id + ' - ' + data.name"></nz-option>
                                        </nz-select>
                                    }
                                    @else{
                                        <input nz-input type="text" formControlName="icon">
                                    }
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="8">
                            <nz-form-item>
                                <nz-form-label>Cor do Ícone</nz-form-label>
                                <nz-form-control>
                                    <input nz-input class="color-input" type="color" formControlName="iconColor">
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="8">
                            <nz-form-item>
                                <nz-form-label>Cor do Fundo do Título</nz-form-label>
                                <nz-form-control>
                                    <input nz-input class="color-input" type="color" formControlName="bgColor">
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="8">
                            <nz-form-item>
                                <nz-form-label>Cor do Texto do Título</nz-form-label>
                                <nz-form-control>
                                    <input nz-input class="color-input" type="color" formControlName="fgColor">
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="24">
                            <nz-form-item>
                                <nz-form-label>Atualização</nz-form-label>
                                <nz-form-control>
                                    <input nz-input type="number" placeholder="Tempo de Atualização em Segundos"
                                        formControlName="refresh" />
                                </nz-form-control>
                            </nz-form-item>
                        </div>
                    </div>
                    <nz-collapse>
                        <nz-collapse-panel nzHeader="Outras configurações" [nzActive]="true">
                            <div class="more-options">
                                <label class="switch-option">
                                    <nz-switch formControlName="isCurrency"></nz-switch>
                                    É moeda?
                                </label>
                            </div>
                        </nz-collapse-panel>
                    </nz-collapse>
                </form>
            </div>
        </div>
        <div class="configuration-fields" *ngIf="rowDetail.name=='query'">
            <query-executor [usePopup]="false" [query]="query" (queryChange)="onQueryChange($event)"
                [showObject]="false" [testMode]="true"></query-executor>
            <suspended-menu *ngIf="filters" title="Filtros" [show]="true" [data]="filters" dropprefix='{@'
                dropsufix='}' heigth="170"></suspended-menu>
        </div>
    </ng-template>
</side-panel>
